
$( function(){
	//addSecondImageProduct();

    $('.product-block .product-link').on('click', function(){

        var _this = $(this);
      	var devVname;
        var timer = setInterval(function(){
          if( _this.parent().next('.product-detail').find('.option-selectors').find('ul').length > 0 ){
            devVname = _this.parent().next('.product-detail').find('.option-selectors ul li a.active').attr('data-value');
            
              $(".devVariants li").each(function() {
                var devName = $(this).attr('data-vname');
                var devImage= $(this).attr('data-img');
                
                if( devVname == devName )
                    {
                      $(_this).parent().next('.product-detail').find(".devVariantImg img").attr('src' ,devImage );
                      $(_this).parent().next('.product-detail').find(".devVariantImg img").css("opacity", "1");
                    }
              });
            
            clearInterval(timer);
          }
        }, 1);
        

    });
  
  
   $('.collection-slider .product-link').on('click', function(){
     
        var _this = $(this);
      	var devVname;
        var timer = setInterval(function(){
          if( _this.parents('.collection-slider').parent().next().find('.option-selectors').find('ul').length > 0 ){
            devVname = _this.parents('.collection-slider').parent().next().find('.option-selectors ul li a.active').attr('data-value');
            
            console.log(devVname);
            
              $(".devVariants li").each(function() {
                var devName = $(this).attr('data-vname');
                var devImage= $(this).attr('data-img');
                
                if( devVname == devName )
                    {
                      _this.parents('.collection-slider').parent().next().find(".devVariantImg img").attr('src' ,devImage );
                      _this.parents('.collection-slider').parent().next().find(".devVariantImg img").css("opacity", "1");                    
                    }
              });
            
            clearInterval(timer);
          }
        }, 1);
        

    });
  
	  
    // function addSecondImageProduct(){
    //   setTimeout( function(){
    //     var devVname = $('.option-selectors ul li a.active').attr('data-value');
    //     $(".devVariants li").each(function() {

    //       var devName = $(this).attr('data-vname');
    //       var devImage= $(this).attr('data-img');

    //       if( devVname == devName )
    //       {
    //         $(".devVariantImg img").attr('src' ,devImage );
    //         $(".devVariantImg img").css("opacity", "1");
    //       }

    //       if(devVname.indexOf('Manufacturer') > -1 ){
    //        $('.dev_bottomDesc').hide();
    //        $('.template-product .dev_topDesc').hide();
    //        $('.collection-listing  .dev_topDesc').css('opacity', 0);
    //      }else{
    //        $('.dev_bottomDesc').show();
    //        $('.collection-listing .dev_topDesc').css('opacity', 1);
    //        $('.template-product .dev_topDesc').show();
    //      }

    //     });
    //   }, 800);
    // }
  
      
  // $('.page-header .filters .tags').on('click' , function(){
  //   $(this).toggleClass('active');
  //   $('.tags.nav-row.spaced-row.desktop-only').slideToggle();
  // });

  $('.tags[data-toggle-target=".tags.nav-row.cat-custom-1"]').on('click' , function(e){
    e.preventDefault();
    $('.tags.nav-row.cat-custom-1').slideToggle();
  });

  // $('.tags[data-toggle-target=".tags.nav-row.cat-custom-2"]').on('click' , function(){
  //   $(this).toggleClass('active');
  //   $('.tags.nav-row.cat-custom-2').slideToggle();
  // });  

  $('.tags[data-toggle-target=".tags.nav-row.cat-custom-2"]').on('click' , function(e){
    e.preventDefault();
    $('div.tags.nav-row.cat-custom-2').slideToggle();
  });  


  $(".devCustomFilters .tags").on("click" , function(e){
    e.preventDefault();
    $(this).toggleClass('active');
  });


  $(".tier-1 > ul > li > a.has-children").on("click" , function(e){
    if ($(window).width() > 767) {
      e.preventDefault();
      if( $(this).hasClass("hsChildNav") ){
        $('.tier-1 > ul > li > a.has-children').removeClass("hsChildNav");
        $(this).removeClass("hsChildNav");
        $('.tier-2').slideUp();
      } else {
        $('.tier-1 > ul > li > a.has-children').removeClass("hsChildNav");
        $(this).addClass("hsChildNav");
        var devInnerHtml = $(this).next('ul').html();
        $(this).addClass("hsChildNav");
        $('.tier-2 ul').html(devInnerHtml);
        $('.tier-2').slideDown();
      }
    }
  });
  
  $(document).on('click', '.tier-2 > ul > li > a.has-children', function(e){
    if ($(window).width() > 767) {
      e.preventDefault();    
      if( $(this).hasClass("hsChildNav") ){
        $('.tier-2 > ul > li > a.has-children').removeClass("hsChildNav");
        $(this).removeClass("hsChildNav");
        $('.tier-3').slideUp();
      } else {
        $('.tier-2 > ul > li > a.has-children').removeClass("hsChildNav");
        $(this).addClass("hsChildNav");
        var devInnerHtml = $(this).next('ul').html();
        $(this).addClass("hsChildNav");
        $('.tier-3 ul').html(devInnerHtml);
        $('.tier-3').slideDown();
      }
    }
  });

    // console.log('laoded inside size chart');
    // $(document).on('click', '.size-chart-link', function(e){
    //   e.preventDefault();
    //   $.fancybox($.extend({}, theme.fbOpts(), {
    //     content: $(this).closest('.size-chart-container').find('.size-chart-content').html()
    //   }));
    //   return false;
    // });


    $(document).on('click', '.size-chart-link', function(e){
      e.preventDefault();
      var devSizeChartPopup = $(this).closest('.size-chart-container').find('.size-chart-content').html();
       $.fancybox.open(devSizeChartPopup);  
      
    });

      // $('.size-chart-link').on('click', function() {
      //     $.fancybox.open({
      //         src  : '#devSizeChartPopup',
      //         type : 'inline'
      //     });
      // });
  
  
});



